import { NavLink, Outlet } from "react-router-dom";
import { Award, Flag, Shield, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Shell mobile-first com barra de abas inferior — mesma estrutura e ícones
// do app original (Torneio, Rankings, Perfil, Admin condicional).
// A aba "Jogos" foi removida por decisão de produto (2026-07-15).
const TABS = [
  { to: "/", label: "Torneio", icon: Flag },
  { to: "/rankings", label: "Rankings", icon: Award },
  { to: "/perfil", label: "Perfil", icon: User },
] as const;

export function AppShell() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin" || user?.role === "super_admin";

  const tabs = isAdmin
    ? [...TABS, { to: "/admin", label: "Admin", icon: Shield } as const]
    : TABS;

  return (
    <div className="mx-auto flex h-full max-w-lg flex-col">
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      <nav className="fixed inset-x-0 bottom-0 z-10 border-t border-border bg-surface-alt/95 backdrop-blur">
        <div className="mx-auto flex max-w-lg items-stretch justify-around px-2 pb-[env(safe-area-inset-bottom)]">
          {tabs.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                `flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-tint" : "text-muted-foreground"
                }`
              }
            >
              <Icon size={22} strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
